<header class="header">
    <div class="header-grp">
        <div class="icon" (click)="goBackToPrevPage()">
            <i class="ti ti-chevron-left"></i>
        </div>
        <div class="title">
            <h3>Bhatar</h3>
        </div>
    </div>
</header>
<main>
    <mat-tab-group mat-stretch-tabs="true" mat-align-tabs="center">
        <mat-tab label="People">
            <div class="main-members">
                <a class="member-list-item" routerLink="/committee/member-details">
                    <img src="../../../assets/img/user1.webp" />
                    <div>
                        <h5>Timir Patel</h5>
                        <p>9876543210 | Amreli</p>
                    </div>
                </a>
                <a class="member-list-item" routerLink="/committee/member-details">
                    <img src="../../../assets/img/user1.webp" />
                    <div>
                        <h5>Timir Patel</h5>
                        <p>9876543210 | Amreli</p>
                    </div>
                </a>
                <a class="member-list-item" routerLink="/committee/member-details">
                    <img src="../../../assets/img/user1.webp" />
                    <div>
                        <h5>Timir Patel</h5>
                        <p>9876543210 | Amreli</p>
                    </div>
                </a>
                <a class="member-list-item" routerLink="/committee/member-details">
                    <img src="../../../assets/img/user1.webp" />
                    <div>
                        <h5>Timir Patel</h5>
                        <p>9876543210 | Amreli</p>
                    </div>
                </a>
                <a class="member-list-item" routerLink="/committee/member-details">
                    <img src="../../../assets/img/user1.webp" />
                    <div>
                        <h5>Timir Patel</h5>
                        <p>9876543210 | Amreli</p>
                    </div>
                </a>
                <a class="member-list-item" routerLink="/committee/member-details">
                    <img src="../../../assets/img/user1.webp" />
                    <div>
                        <h5>Timir Patel</h5>
                        <p>9876543210 | Amreli</p>
                    </div>
                </a>
                <a class="member-list-item" routerLink="/committee/member-details">
                    <img src="../../../assets/img/user1.webp" />
                    <div>
                        <h5>Timir Patel</h5>
                        <p>9876543210 | Amreli</p>
                    </div>
                </a>
                <a class="member-list-item" routerLink="/committee/member-details">
                    <img src="../../../assets/img/user1.webp" />
                    <div>
                        <h5>Timir Patel</h5>
                        <p>9876543210 | Amreli</p>
                    </div>
                </a>
                <a class="member-list-item" routerLink="/committee/member-details">
                    <img src="../../../assets/img/user1.webp" />
                    <div>
                        <h5>Timir Patel</h5>
                        <p>9876543210 | Amreli</p>
                    </div>
                </a>
                <a class="member-list-item" routerLink="/committee/member-details">
                    <img src="../../../assets/img/user1.webp" />
                    <div>
                        <h5>Timir Patel</h5>
                        <p>9876543210 | Amreli</p>
                    </div>
                </a>
                <a class="member-list-item" routerLink="/committee/member-details">
                    <img src="../../../assets/img/user1.webp" />
                    <div>
                        <h5>Timir Patel</h5>
                        <p>9876543210 | Amreli</p>
                    </div>
                </a>
                <a class="member-list-item" routerLink="/committee/member-details">
                    <img src="../../../assets/img/user1.webp" />
                    <div>
                        <h5>Timir Patel</h5>
                        <p>9876543210 | Amreli</p>
                    </div>
                </a>
            </div>
        </mat-tab>
        <mat-tab label="Family">
            <div class="main-members family-tabs">
                <a class="member-list-item" routerLink="/committee/member-details">
                    <img src="../../../assets/img/user1.webp" />
                    <div>
                        <h5>Timir Patel</h5>
                        <p>9876543210</p>
                    </div>
                    <span><i class="ti ti-users-group"></i> 1</span>
                </a>
                <a class="member-list-item" routerLink="/committee/member-details">
                    <img src="../../../assets/img/user1.webp" />
                    <div>
                        <h5>Timir Patel</h5>
                        <p>9876543210</p>
                    </div>
                    <span><i class="ti ti-users-group"></i> 1</span>
                </a>
                <a class="member-list-item" routerLink="/committee/member-details">
                    <img src="../../../assets/img/user1.webp" />
                    <div>
                        <h5>Timir Patel</h5>
                        <p>9876543210</p>
                    </div>
                    <span><i class="ti ti-users-group"></i> 1</span>
                </a>
                <a class="member-list-item" routerLink="/committee/member-details">
                    <img src="../../../assets/img/user1.webp" />
                    <div>
                        <h5>Timir Patel</h5>
                        <p>9876543210</p>
                    </div>
                    <span><i class="ti ti-users-group"></i> 1</span>
                </a>
                <a class="member-list-item" routerLink="/committee/member-details">
                    <img src="../../../assets/img/user1.webp" />
                    <div>
                        <h5>Timir Patel</h5>
                        <p>9876543210</p>
                    </div>
                    <span><i class="ti ti-users-group"></i> 1</span>
                </a>
                <a class="member-list-item" routerLink="/committee/member-details">
                    <img src="../../../assets/img/user1.webp" />
                    <div>
                        <h5>Timir Patel</h5>
                        <p>9876543210</p>
                    </div>
                    <span><i class="ti ti-users-group"></i> 1</span>
                </a>
                <a class="member-list-item" routerLink="/committee/member-details">
                    <img src="../../../assets/img/user1.webp" />
                    <div>
                        <h5>Timir Patel</h5>
                        <p>9876543210</p>
                    </div>
                    <span><i class="ti ti-users-group"></i> 1</span>
                </a>
                <a class="member-list-item" routerLink="/committee/member-details">
                    <img src="../../../assets/img/user1.webp" />
                    <div>
                        <h5>Timir Patel</h5>
                        <p>9876543210</p>
                    </div>
                    <span><i class="ti ti-users-group"></i> 1</span>
                </a>
                <a class="member-list-item" routerLink="/committee/member-details">
                    <img src="../../../assets/img/user1.webp" />
                    <div>
                        <h5>Timir Patel</h5>
                        <p>9876543210</p>
                    </div>
                    <span><i class="ti ti-users-group"></i> 1</span>
                </a>
                <a class="member-list-item" routerLink="/committee/member-details">
                    <img src="../../../assets/img/user1.webp" />
                    <div>
                        <h5>Timir Patel</h5>
                        <p>9876543210</p>
                    </div>
                    <span><i class="ti ti-users-group"></i> 1</span>
                </a>
                <a class="member-list-item" routerLink="/committee/member-details">
                    <img src="../../../assets/img/user1.webp" />
                    <div>
                        <h5>Timir Patel</h5>
                        <p>9876543210</p>
                    </div>
                    <span><i class="ti ti-users-group"></i> 1</span>
                </a>
                <a class="member-list-item" routerLink="/committee/member-details">
                    <img src="../../../assets/img/user1.webp" />
                    <div>
                        <h5>Timir Patel</h5>
                        <p>9876543210</p>
                    </div>
                    <span><i class="ti ti-users-group"></i> 1</span>
                </a>
            </div>
        </mat-tab>
    </mat-tab-group>
</main>